export default __webpack_public_path__ + "047b887a226f865b451bfcad3015b7d0.jpg";